import { postRequest } from './requests';
import { getCloudActionErrorMessage } from 'utils/cloudManagement';
import { showNotif } from 'utils/notification';

interface ActionPayload {
  action: string;
  gatewayId: string;
  customerId: string;
}

export const runAction = ({ action, gatewayId, customerId }: ActionPayload) => {
  const path = '/cloud/management/run-action';
  const REQ_BODY = { action, gatewayId, customerId };
  postRequest(path, REQ_BODY)
    .then(() => {
      showNotif({
        message: `The action ${action} has been successfully executed on the gateway ${gatewayId}`,
        kind: 'success',
        dismissAfter: 8000,
        type: 'alert'
      });
    })
    .catch(err => {
      showNotif({
        message: getCloudActionErrorMessage(err),
        kind: 'error',
        dismissAfter: 8000,
        type: 'alert'
      });
    });
};

interface JobPayload {
  customerId: string;
  networkId: string;
}

/*
 * Operator controls for a cloud-management job that is not progressing.
 *
 * Force-release is the audited replacement for the manual Redis HDEL that was
 * previously the only way to unblock a network (P81-143028). Both resolve to
 * true on success so the caller can refresh its view.
 */

const postJobAction = (
  path: string,
  { customerId, networkId }: JobPayload,
  successMessage: string
): Promise<boolean> =>
  postRequest(`/cloud/management/jobs/${path}`, { customerId, networkId })
    .then(() => {
      showNotif({
        message: successMessage,
        kind: 'success',
        dismissAfter: 6000,
        type: 'alert'
      });
      return true;
    })
    .catch(err => {
      showNotif({
        message: getCloudActionErrorMessage(err),
        kind: 'error',
        dismissAfter: 8000,
        type: 'alert'
      });
      return false;
    });

export const releaseCloudJob = (payload: JobPayload): Promise<boolean> =>
  postJobAction(
    'release',
    payload,
    `The stuck job on network ${payload.networkId} has been released. You can run a new action now.`
  );

export const retryCloudJob = (payload: JobPayload): Promise<boolean> =>
  postJobAction(
    'retry',
    payload,
    `The action on network ${payload.networkId} has been re-issued.`
  );
